module.exports = {
      id: "profile-usage",
      viewBox: "0 0 18 19",
      url: __webpack_public_path__ + "svg-sprite.svg#profile",
      toString: function () {
        return this.url;
      }
    }